import React from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  PageListBean,
  PickedPickticketLineLabelRequest,
  PickTicketSearchCriteria,
  PrintPickTicketInquiryCriteriaBean,
  PrintPickTicketPrintOutCriteriaBean,
  RemainingPickticketLineLabelRequest,
  RestCustomerListRequest,
  RestPageListBean,
  RestPickTicketListRequest,
  RestReadRequest,
  RestSalesOrderRequest,
  SalesOrderSearchCriteria,
  SKUBatchInventoryBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { PickTicketLookupHandler } from "../lookup/PickTicketLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { ReportService } from "../services/ReportService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { BaseInquiryToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
class PickTicketRollUtility extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      pageTitle: "PickTicket Roll Utility",
      error_list: [],
      inquiryDataList: [],
      selectedRollSkuList: [],
      criteria: new PrintPickTicketInquiryCriteriaBean(),
      inventoryData: new SKUBatchInventoryBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      moduleForPopup: [],
      isShowExitButton: true,
      isDisabledFields: false,
      isShowLookup: true,
      customerLookupHandler: null,
      salesOrderLookupHandler: null,
      pickTicketLookupHandler: null,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesOrderList: true,
      showAutoCompleteCustomerList: true,
      salesOrderListForAutoCompleteList: new Array(),
      showAutoCompletePickTicketList: true,
      pickTicketListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.initLookupHandlers();
    ModuleUtils.getPickTicketStatusList();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrderNumber"
    );
    this.setState({
      salesOrderLookupHandler: salesOrderLookupHandler,
    });
    let pickTicketLookupHandler = new PickTicketLookupHandler(
      this.companyCode,
      "PickTicket"
    );
    this.setState({
      pickTicketLookupHandler: pickTicketLookupHandler,
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ critera: tempCriteria });
  };
  readandsetCustomterDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomterDetailResponse,
      this.errorCallBack
    );
  };
  readandsetCustomterDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readCustomerBySearchString = (searchString) => {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pagelist = new RestPageListBean();
    customer_pagelist.pageSize = 100;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pagelist;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  };
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomterDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  salesOrderOnChange = (e) => {
    let salesOrderNumber = e.target.value;
    this.state.showAutoCompleteSalesOrderList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
    if (isEmpty(salesOrderNumber)) {
      this.state.showAutoCompleteSalesOrderList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesOrderList: showAutoCompleteList,
        criteria: criteria,
        salesOrderListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrderNumber !== ""
    ) {
      this.readSalesOrderBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetSalesOrderDetail = (salesOrderNumber) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = salesOrderNumber;
    input.isLoadChildren = true;
    SalesOrderService.readSalesOrder(
      input,
      this.readandsetSalesOrderDetailResponse,
      this.errorCallBack
    );
  };
  readandsetSalesOrderDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.salesOrder != null) {
      let salesOrderData = response.data.salesOrder;
      if (!isEmpty(salesOrderData)) {
        criteria.salesOrderNumber = salesOrderData.code;
        this.setState({
          criteria: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readSalesOrderBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companycode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.readBySalesOrderCodeResponse,
      this.errorCallBack
    );
  }
  readBySalesOrderCodeResponse = (response) => {
    let salesOrderNumberData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesOrderNumberData.length > 0 && salesOrderNumberData != null) {
      salesOrderNumberData.map((salesOrderNumber) => {
        let simpleItemBean = {
          code: salesOrderNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesOrderListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  salesOrderEnterKeyEventHandler = (e) => {
    let salesOrderNumber = e.target.value;
    this.readandsetSalesOrderDetail(salesOrderNumber);
    this.setState({
      salesOrderListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
  };
  displayAutoCompleteSalesOrderList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteSalesOrderList: showAutoCompleteList,
    });
  };
  pickTicketOnChange = (e) => {
    let pickTicketNumber = e.target.value;
    this.state.showAutoCompletePickTicketList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePickTicketList;
    if (isEmpty(pickTicketNumber)) {
      this.state.showAutoCompletePickTicketList = false;
      let showAutoCompleteList = this.state.showAutoCompletePickTicketList;
      let criteria = this.state.criteria;
      criteria.pickTicketNumber = "";
      criteria.status = "";
      criteria.salesOrderNumber = "";
      criteria.customerCode = "";
      criteria.customerName = "";
      criteria.fromPickedDate = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePickTicketList: showAutoCompleteList,
        criteria: criteria,
        pickTicketListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "pickTicketNumber" &&
      showAutoCompleteList === true &&
      pickTicketNumber !== ""
    ) {
      this.readPickTicketBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetPickTicketDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.pickTicket != null) {
      let pickTicketData = response.data.pickTicket;
      if (!isEmpty(pickTicketData)) {
        criteria.pickTicketNumber = pickTicketData.code;
        criteria.status = ModuleUtils.getPickTicketStatusCaption(
          pickTicketData.status
        );
        criteria.salesOrderNumber = pickTicketData.salesOrderNumber;
        criteria.customerCode = pickTicketData.customerCode;
        criteria.customerName = pickTicketData.customerName;
        criteria.fromPickedDate = pickTicketData.createdDate;
        this.setState({
          criteria: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetPickTicketDetail = (pickTicketNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
    let listrequest = new RestReadRequest();
    listrequest.companyCode = this.companyCode;
    listrequest.code = pickTicketNumber;
    listrequest.isLoadChildren = true;
    PickTicketService.readPickTicket(
      listrequest,
      this.readandsetPickTicketDetailResponse,
      this.errorCallBack
    );
  };
  readPickTicketBySearchString(searchString) {
    let searchCriteria = new PickTicketSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.pickTicketStartsWith = searchString;
    searchCriteria.pickTicketContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestPickTicketListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    PickTicketService.getPickTicketPageList(
      input,
      this.readByPickTicketCodeResponse,
      this.errorCallBack
    );
  }
  readByPickTicketCodeResponse = (response) => {
    let pickTicketCodeData = response.data.pickTicketPageList.pickTickets;
    let simpleAutoCompleteList = new Array();
    if (pickTicketCodeData.length > 0 && pickTicketCodeData != null) {
      pickTicketCodeData.map((pickTicketNumber) => {
        let simpleItemBean = {
          code: pickTicketNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      pickTicketListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  pickTicketEnterKeyEventHandler = (e) => {
    let pickTicketNumber = e.target.value;
    this.readandsetPickTicketDetail(pickTicketNumber);
    this.setState({
      pickTicketListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePickTicketList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePickTicketList: showAutoCompleteList });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (!isEmptyString(criteria.pickTicketNumber)) {
      this.loadPickTicketRollUtilityList(criteria);
    } else {
      let errMsg = "PickTicket# is required!";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadPickTicketRollUtilityList = (criteria) => {
    if (SecurityAccessManager.PrintPickTickLabelMaintenance_IsAccessible()) {
      ReportService.inquirePrintPickTicketInfos(
        criteria,
        this.loadPickTicketRollUtilityPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPickTicketRollUtilityPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.pickTicketInfos)) {
        resultList = response.data.pickTicketInfos;
      }
      this.setState({
        inquiryDataList: resultList,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  lineSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedRollSkuList: list });
    }
  };
  lineUnSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = false;
      });
      this.setState({ selectedRollSkuList: [] });
    }
  };
  generatePrintRemainingQtyLabel = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating ...",
      });
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let roll_criteria = new PrintPickTicketPrintOutCriteriaBean();
      roll_criteria.companyCode = this.companyCode;
      roll_criteria.pickInfos = selectedRollSkuList;
      let reportBean = new RestReportBean();
      reportBean.reportType = 1;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RemainingPickticketLineLabelRequest();
      listRequest.criteria = roll_criteria;
      listRequest.input = reportBean;
      if (!isEmptyArray(selectedRollSkuList)) {
        this.hideAlertCallBack();
        if (SecurityAccessManager.PrintPickTickLabelCreate_IsAccessible()) {
          ReportService.printRemainingPickticketLineLabel(
            listRequest,
            this.generatePrintRemainingQtyLabelResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(2);
        }
      } else {
        let errMsg = "Select the Line";
        let error_list = [];
        error_list.push(errMsg);
        this.setState({
          alertMessage: error_list,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  generatePrintRemainingQtyLabelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.loadPage();
    this.setState({
      selectedRollSkuList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePrintShipLabel = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating ...",
      });
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let roll_criteria = new PrintPickTicketPrintOutCriteriaBean();
      roll_criteria.companyCode = this.companyCode;
      roll_criteria.pickInfos = selectedRollSkuList;
      let reportBean = new RestReportBean();
      reportBean.reportType = 1;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new PickedPickticketLineLabelRequest();
      listRequest.criteria = roll_criteria;
      listRequest.input = reportBean;
      if (!isEmptyArray(selectedRollSkuList)) {
        this.hideAlertCallBack();
        if (SecurityAccessManager.PrintPickTickLabelCreate_IsAccessible()) {
          ReportService.printPickedPickticketLineLabel(
            listRequest,
            this.generatePrintShipLabelResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(2);
        }
      } else {
        let errMsg = "Select the Line";
        let error_list = [];
        error_list.push(errMsg);
        this.setState({
          alertMessage: error_list,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  generatePrintShipLabelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.loadPage();
    this.setState({
      selectedRollSkuList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  adjusteedToZero = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating ...",
      });
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let roll_criteria = new PrintPickTicketPrintOutCriteriaBean();
      roll_criteria.companyCode = this.companyCode;
      roll_criteria.pickInfos = selectedRollSkuList;
      if (!isEmptyArray(selectedRollSkuList)) {
        this.hideAlertCallBack();
        if (
          SecurityAccessManager.PrintPickTickLabelMaintenance_IsAccessible()
        ) {
          InventoryService.adjustPickTicketQuantityToZero(
            roll_criteria,
            this.loadAdjustToBeZeroResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(2);
        }
      } else {
        let errMsg = "Select the Line";
        let error_list = [];
        error_list.push(errMsg);
        this.setState({
          alertMessage: error_list,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  loadAdjustToBeZeroResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let isValid = this.handleResponse(response.data);
      if (isValid == true) {
        this.adjustLinesToZero();
      }
    }
    this.setState({
      selectedRollSkuList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  adjustLinesToZero = () => {
    let selectedRollSkuList = this.state.selectedRollSkuList;
    let selectedLine = new Array();
    for (let list of selectedRollSkuList) {
      list.toBePickedQuantity = 0;
      selectedLine.push(list);
    }
    this.setState({ selectedRollSkuList: selectedLine });
  };
  handleResponse = (response) => {
    let isValid = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.infos != null) {
      response.infos.map(
        (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
      );
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      isValid = true;
    }
    if (response.errors != null) {
      response.errors.map(
        (err) => (
          (errMsg = errMsg + "\n" + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      isValid = false;
    }
    return isValid;
  };
  rollLineCheck = (val, rowData) => {
    let selectedLine = [];
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedRollSkuList: selectedLine });
    } else {
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let rollList = [];
      for (let roll of selectedRollSkuList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedRollSkuList: rollList });
        } else if (selectedRollSkuList.length == 1) {
          this.setState({ selectedRollSkuList: [] });
        }
      }
    }
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.rollLineCheck
        )
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode")
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode"
        )
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "fabricStyleName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "colorCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ToBePicked",
        "toBePickedQuantity",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Picked Qty",
        "pickedQuantity",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "onHand Qty",
        "onHandQuantity",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WareHouse", "wareHouseCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("BinLocation", "binLocation")
    );

    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new PrintPickTicketInquiryCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    this.setState({
      criteria: tempCriteria,
    });
    this.hideAlertCallBack();
  };
  resetView = () => {
    let criteria = new PrintPickTicketInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowLookup: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisabledFields: false,
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          onModuleExit={this.moduleExit}
          reset={this.resetView}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesOrderOnChange={this.salesOrderOnChange}
          salesOrderEnterKeyEventHandler={this.salesOrderEnterKeyEventHandler}
          displayAutoCompleteSalesOrderList={
            this.displayAutoCompleteSalesOrderList
          }
          pickTicketOnChange={this.pickTicketOnChange}
          pickTicketEnterKeyEventHandler={this.pickTicketEnterKeyEventHandler}
          displayAutoCompletePickTicketList={
            this.displayAutoCompletePickTicketList
          }
        />
        {this.state.isInquiryDatasFound && (
          <Row>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.lineSelectAll(e)}
              >
                SelectAll
              </Button>
            </Col>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.lineUnSelectAll(e)}
              >
                UnSelectAll
              </Button>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.generatePrintShipLabel(e)}
              >
                Print ShipLabel
              </Button>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.generatePrintRemainingQtyLabel(e)}
              >
                Print RemQtyLabel
              </Button>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.adjusteedToZero(e)}
              >
                Adjusted ToZero
              </Button>{" "}
            </Col>
          </Row>
        )}
        {this.state.isInquiryDatasFound && (
          <>
            <Row>
              <FormLabel className="table_title">Pickticket RollList</FormLabel>
            </Row>
            <div className="div_default">
              <EditableDataGrid
                columnsList={this.columnDefinitions()}
                dataList={inquiryDataList}
              />
            </div>
          </>
        )}
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const pickTicketOnChange = (e) => {
    props.pickTicketOnChange(e);
  };
  const pickTicketEnterKeyEventHandler = (e) => {
    props.pickTicketEnterKeyEventHandler(e);
  };
  const displayAutoCompletePickTicketList = () => {
    props.displayAutoCompletePickTicketList();
  };
  const salesOrderOnChange = (e) => {
    props.salesOrderOnChange(e);
  };
  const salesOrderEnterKeyEventHandler = (e) => {
    props.salesOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesOrderList = () => {
    props.displayAutoCompleteSalesOrderList();
  };
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  let criteria = props.criteria;
  const customerCodeRef = props.customerCodeRef;
  let pickTicketRef = React.createRef();
  let salesOrderRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel sm="1">PickTicket Number</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={pickTicketRef}
            name="pickTicketNumber"
            value={criteria.pickTicketNumber}
            onChange={pickTicketOnChange}
            lookupRequired={props.isShowLookup}
            showCriteriaDialog={true}
            lookupHandler={props.pickTicketLookupHandler}
            enterKeyEventHandler={pickTicketEnterKeyEventHandler}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePickTicketList}
            autoCompleteListData={props.pickTicketListForAutoCompleteList}
            showAutoCompleteList={props.showAutoCompletePickTicketList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>PickTicketDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="fromPickedDate"
            value={criteria.fromPickedDate}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Status</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="status"
            onChange={onChange}
            value={criteria.status}
            disabled={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          <FormLabel>SalesOrder Number</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={salesOrderRef}
            name="salesOrderNumber"
            value={criteria.salesOrderNumber}
            onChange={salesOrderOnChange}
            lookupRequired={props.isShowLookup}
            showCriteriaDialog={true}
            lookupHandler={props.salesOrderLookupHandler}
            enterKeyEventHandler={salesOrderEnterKeyEventHandler}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesOrderList}
            autoCompleteListData={props.salesOrderListForAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteSalesOrderList}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={props.isShowLookup}
            showCriteriaDialog={true}
            lookupHandler={props.customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            displayAutoCompleteList={displayAutoCompleteList}
            enableAutoCompleteTextBox={true}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisabledFields}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function PickTicketRollUtilityModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div className="App">
        <PickTicketRollUtility {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default PickTicketRollUtilityModule;
